// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.pdf-card:hover {
  background-color: #f8f9fa;
  transform: scale(1.02);
}

.pdf-icon {
  font-size: 32px;
  color: #dc3545;
}

.pdf-title {
  font-weight: 600;
}

.pdf-sub {
  font-size: 12px;
  color: #6c757d;
}

/* ===== CASE TIMELINE ===== */

.case-row {
  display: flex;
  position: relative;
  padding: 15px 0;
}

.timeline-col {
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  z-index: 2;
}

.active-dot {
  background-color: #198754;
}

.inactive-dot {
  background-color: #adb5bd;
}

.timeline-line {
  width: 2px;
  flex-grow: 1;
  background-color: #dee2e6;
  margin-top: 2px;
}

/* ===== CONTENT ===== */

.case-content {
  flex: 1 1;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px 18px;
  transition: 0.2s ease;
}

.case-content:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.case-header {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 8px;
}

.case-label {
  color: #212529;
}

.case-date {
  color: #495057;
  font-size: 14px;
}

/* ===== PDF MINI CARD ===== */

.pdf-mini-card {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s ease;
  background-color: #f8f9fa;
}

.pdf-mini-card:hover {
  background-color: #e9ecef;
}

.pdf-icon {
  color: #dc3545;
  font-size: 18px;
}

.no-doc {
  color: #adb5bd;
  font-size: 13px;
}


.case-header-inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  font-weight: 600;
}

.case-label {
  flex: 1 1;
}

.case-date {
  color: #495057;
  font-size: 14px;
  white-space: nowrap;
}

.pdf-inline-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  background-color: #f8f9fa;
  font-size: 13px;
  transition: 0.2s ease;
}

.pdf-inline-btn:hover {
  background-color: #e9ecef;
}

.pdf-inline-btn svg {
  color: #dc3545;
  font-size: 16px;
}



.case-header-inline {
  display: flex;
  align-items: center;
}

.case-col {
  flex: 1 1;               /* Makes all 3 equal width */
  display: flex;
  align-items: center;
}

.case-label {
  justify-content: flex-start;
  font-weight: 600;
}

.case-doc {
  justify-content: center;
}

.case-date {
  justify-content: flex-end;
  font-size: 14px;
  color: #495057;
}


.pdf-table-icon {
  color: #dc3545;
  cursor: pointer;
  font-size: 18px;
  transition: 0.2s ease;
}

.pdf-table-icon:hover {
  transform: scale(1.2);
  color: #a71d2a;
}

.custom-gap {
  gap: 20px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/pages/caseTracking/CaseTrackCasewise1.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;;AAE9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO,gBAAgB,4BAA4B;EACnD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;AACf","sourcesContent":[".pdf-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n}\n\n.pdf-card:hover {\n  background-color: #f8f9fa;\n  transform: scale(1.02);\n}\n\n.pdf-icon {\n  font-size: 32px;\n  color: #dc3545;\n}\n\n.pdf-title {\n  font-weight: 600;\n}\n\n.pdf-sub {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n/* ===== CASE TIMELINE ===== */\n\n.case-row {\n  display: flex;\n  position: relative;\n  padding: 15px 0;\n}\n\n.timeline-col {\n  width: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.timeline-dot {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  z-index: 2;\n}\n\n.active-dot {\n  background-color: #198754;\n}\n\n.inactive-dot {\n  background-color: #adb5bd;\n}\n\n.timeline-line {\n  width: 2px;\n  flex-grow: 1;\n  background-color: #dee2e6;\n  margin-top: 2px;\n}\n\n/* ===== CONTENT ===== */\n\n.case-content {\n  flex: 1;\n  background: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 12px 18px;\n  transition: 0.2s ease;\n}\n\n.case-content:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.case-header {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.case-label {\n  color: #212529;\n}\n\n.case-date {\n  color: #495057;\n  font-size: 14px;\n}\n\n/* ===== PDF MINI CARD ===== */\n\n.pdf-mini-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: 0.2s ease;\n  background-color: #f8f9fa;\n}\n\n.pdf-mini-card:hover {\n  background-color: #e9ecef;\n}\n\n.pdf-icon {\n  color: #dc3545;\n  font-size: 18px;\n}\n\n.no-doc {\n  color: #adb5bd;\n  font-size: 13px;\n}\n\n\n.case-header-inline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  font-weight: 600;\n}\n\n.case-label {\n  flex: 1;\n}\n\n.case-date {\n  color: #495057;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.pdf-inline-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  background-color: #f8f9fa;\n  font-size: 13px;\n  transition: 0.2s ease;\n}\n\n.pdf-inline-btn:hover {\n  background-color: #e9ecef;\n}\n\n.pdf-inline-btn svg {\n  color: #dc3545;\n  font-size: 16px;\n}\n\n\n\n.case-header-inline {\n  display: flex;\n  align-items: center;\n}\n\n.case-col {\n  flex: 1;               /* Makes all 3 equal width */\n  display: flex;\n  align-items: center;\n}\n\n.case-label {\n  justify-content: flex-start;\n  font-weight: 600;\n}\n\n.case-doc {\n  justify-content: center;\n}\n\n.case-date {\n  justify-content: flex-end;\n  font-size: 14px;\n  color: #495057;\n}\n\n\n.pdf-table-icon {\n  color: #dc3545;\n  cursor: pointer;\n  font-size: 18px;\n  transition: 0.2s ease;\n}\n\n.pdf-table-icon:hover {\n  transform: scale(1.2);\n  color: #a71d2a;\n}\n\n.custom-gap {\n  gap: 20px;\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
